import { BFLType } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import BFV_J3 from "./BFV_J3";
import BFV_J5 from "./BFV_J5";
import BFV_J9 from "./BFV_J9";
import { IModuleRound } from "../../../modules/roundHandler";
import BFV_J10 from "./BFV_J10";
import BFK_J1 from "./BFK_J1";
import BFL_J3_FTX_FT from "./BFL_J3_FTX_FT";
import BFL_J3_FX_F from "./BFL_J3_FX_F";
import BFL_J3_S from "./BFL_J3_S";
import BFL_J4_FTX from "./BFL_J4_FTX";
import BFL_J5_FTX_FT from "./BFL_J5_FTX_FT";
import BFV_J4 from "./BFV_J4";
import BFV_J6 from "./BFV_J6";
import BFV_J8 from "./BFV_J8";
import BFV_J11 from "./BFV_J11";
import BFV_J12 from "./BFV_J12";
import BFV_J13 from "./BFV_J13";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
  bfName: BFLType;
}

const BFLEditor = ({ module, formHook, bfName }: IProps) => {
  const getBFLEditor = (module: IModuleRound) => {
    switch (bfName) {
      case BFLType.BFK_J1:
        return <BFK_J1 module={module} formHook={formHook} />;
      case BFLType.BFL_J3_FTX_FT:
        return <BFL_J3_FTX_FT module={module} formHook={formHook} />;
      case BFLType.BFL_J3_FX_F:
        return <BFL_J3_FX_F module={module} formHook={formHook} />;
      case BFLType.BFL_J3_S:
        return <BFL_J3_S module={module} formHook={formHook} />;
      case BFLType.BFL_J4_FTX:
        return <BFL_J4_FTX module={module} formHook={formHook} />;
      case BFLType.BFL_J5_FTX_FT:
        return <BFL_J5_FTX_FT module={module} formHook={formHook} />;
      case BFLType.BFV_J3:
        return <BFV_J3 module={module} formHook={formHook} />;
      case BFLType.BFV_J4:
        return <BFV_J4 module={module} formHook={formHook} />;
      case BFLType.BFV_J5:
        return <BFV_J5 module={module} formHook={formHook} />;
      case BFLType.BFV_J6:
        return <BFV_J6 module={module} formHook={formHook} />;
      case BFLType.BFV_J8:
        return <BFV_J8 module={module} formHook={formHook} />;
      case BFLType.BFV_J9:
        return <BFV_J9 module={module} formHook={formHook} />;
      case BFLType.BFV_J10:
        return <BFV_J10 module={module} formHook={formHook} />;
      case BFLType.BFV_J11:
        return <BFV_J11 module={module} formHook={formHook} />;
      case BFLType.BFV_J12:
        return <BFV_J12 module={module} formHook={formHook} />;
      case BFLType.BFV_J13:
        return <BFV_J13 module={module} formHook={formHook} />;
      case BFLType.NotYetImplemented:
        return <>BFL Not yet implemented</>;
      default:
        return <>BFL unknown?...</>;
    }
  };

  return <>{getBFLEditor(module)}</>;
};

export default BFLEditor;
